// src/redux/auth/authRecoveryActions.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from './axios';

export const forgotPasswordThunk = createAsyncThunk(
  'authRecovery/forgotPassword',
  async (email, { rejectWithValue }) => {
    try {
      const response = await apiClient.post('/forgot-password', { email });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Failed to send reset email');
    }
  }
);

export const resetPasswordThunk = createAsyncThunk(
  'authRecovery/resetPassword',
  async ({ token, newPassword }, { rejectWithValue }) => {
    try {
      const response = await apiClient.post(`/reset-password/${token}`, {
        new_password: newPassword
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Failed to reset password');
    }
  }
);

export const sendVerificationThunk = createAsyncThunk(
  'authRecovery/sendVerification',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiClient.post('/send-verification');
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Failed to send verification');
    }
  }
);

export const verifyEmailThunk = createAsyncThunk(
  'authRecovery/verifyEmail',
  async (token, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(`/verify-email/${token}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Verification failed');
    }
  }
);
